import { CalendarLayoutLeftPaneConstants } from '../constants';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Get the minimum width of the Left pane on the surface
 */
export default function getLeftPaneMinWidth(): number {
    return getUserConfiguration().UserOptions.ShowWeekNumbers
        ? CalendarLayoutLeftPaneConstants.leftPaneMinWidthWithWeekNumbers
        : CalendarLayoutLeftPaneConstants.leftPaneMinWidthWithoutWeekNumbers;
}
